var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-runtime-template',_vm._g(_vm._b({attrs:{"template":_vm.compiledTemplate,"parent":_vm.$parent}},'c-runtime-template',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }